import React from 'react'
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import ModuleRecordsPerPageDropdown from '../../../../UI/modules/views/partials/common/ModuleRecordsPerPageDropdown';
import ModuleSearchBox from '../../../../UI/modules/views/partials/common/ModuleSearchBox';
import ModuleStatusDropdown from '../../../../UI/modules/views/partials/common/ModuleStatusDropdown';
import ModuleDynamicFilterDropdown from '../../../../UI/modules/views/partials/common/ModuleDynamicFilterDropdown';

const SearchArea = ({ moduleConfig, setFilter, appliedFilters, resetFilters, isActivityFree }) => {
    //console.log(appliedFilters);

    const getStatusFiltersAsPerActivityType = () => {
        let filters = [
            {
                label: "Select Status...",
                value: "all"
            }]

        if (isActivityFree) {
            // filters.push({
            //     label: "Confirmed Members",
            //     value: "reconfirmedMembers"
            // })
            filters.push({
                label: "Registered Members",
                value: "confirmedMembers"
            })
        } else {
            filters = [
                ...filters,
                {
                    label: "Confirmed Members",
                    value: "confirmedMembers"
                },
                {
                    label: "Pending Members",
                    value: "pendingMembers"
                },
                {
                    label: "Responded Admin Approvals",
                    value: "respondedAdminApprovals"
                },
                {
                    label: "Pending Admin Approvals",
                    value: "pendingAdminApprovals"
                }
            ]
        }
        return filters
    }


    return (
        <Card className="listingPageHeader p-0 m-0 p-1 mt-2 mb-1">
            <Card.Body className="m-0 p-0 ">

                {
                    (
                        (appliedFilters.limit)
                        || (appliedFilters.q)
                        || (appliedFilters.status)
                    ) &&
                    <div div className="resetFilters text-right" onClick={() => resetFilters()}>
                        <span>
                            <i className="fas fa-times" /> Reset Filters
                        </span>
                    </div>
                }

                <Row className="header">

                    {
                        (moduleConfig.hasPagination === true && moduleConfig.perPageItemsOptions && moduleConfig.perPageItemsOptions.length > 0) &&
                        <Col className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 pt-0" >
                            <ModuleRecordsPerPageDropdown
                                selectedPerPageItems={moduleConfig.perPageItems}
                                perPageItemsOptions={moduleConfig.perPageItemsOptions}
                                setFilter={setFilter}
                            />
                        </Col>
                    }
                    {
                        (moduleConfig.hasStatusSearch === true && !isActivityFree) &&
                        <Col className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 pt-1" >
                            <ModuleStatusDropdown
                                setFilter={setFilter}
                                appliedFilters={appliedFilters}
                                statusOptions={getStatusFiltersAsPerActivityType()}
                            />
                        </Col>
                    }
                    {/* <Col className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 col-12 pt-xl-0 pt-lg-0 pt-md-0 pt-1" >
                    <ModuleDynamicFilterDropdown
                                filterField='attended'
                                setFilter={setFilter}
                                appliedFilters={appliedFilters}
                                options={[
                                    {
                                        label: "Select Attended...",
                                        value: "all"
                                    },
                                    {
                                        label: "Attended",
                                        value: "attended"
                                    },
                                    {
                                        label: "Not Attended",
                                        value: "not-attended"
                                    }
                                ]}
                            />
                    </Col> */}
                </Row>

            </Card.Body>
        </Card>
    )
}

export default SearchArea